import { useCallback } from 'react';
import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import { useSnackbar } from '@/features/snackbar';

function useCopyUrlToClipboard() {
  const { addSnackbar } = useSnackbar();
  const { isMobile, isTablet } = useUserAgent();
  const copyFn = useCallback(async () => {
    const device =
      RUNTIME_ENV === 'native'
        ? 'native'
        : isMobile || isTablet
          ? 'mobile'
          : 'web';
    const url = `https://simplywall.st${window.location.pathname}`;
    const urlWithParams = `${url}?utm_source=share&utm_medium=${device}`;

    try {
      if (device === 'native') {
        const { Clipboard } = await import('@capacitor/clipboard');
        return await Clipboard.write({
          string: urlWithParams,
        }).then(() => {
          addSnackbar({
            message: 'Link copied',
            type: 'positive',
            lifeTime: 3000,
          });
        });
      }

      return await navigator.clipboard.writeText(urlWithParams).then(() => {
        addSnackbar({
          message: 'Link copied',
          type: 'positive',
          lifeTime: 3000,
        });
      });
    } catch (error) {
      addSnackbar({
        message: 'Error copying link',
        type: 'negative',
        lifeTime: 3000,
      });
      return;
    }
  }, [addSnackbar, isTablet, isMobile]);

  return copyFn;
}
export default useCopyUrlToClipboard;
